const INDENT = "  ",
      XML_CODE_TYPE = "xml",
      XML_MIME_TYPE = "application/xml",
      CDATA_SECTION_NODE = 4,
      ELEMENT_NODE = 1,
      TEXT_NODE = 3

export default (() => {
  const hasMixedContent = xmlDoc => Array.from(xmlDoc.getElementsByTagName("*")).some(element => {
    const childNodes = Array.from(element.childNodes),
          hasElement = childNodes.some(node => node.nodeType === ELEMENT_NODE),
          hasText = childNodes.some(node => node.nodeType === TEXT_NODE && node.nodeValue.trim())

    return hasElement && hasText
  })

  const hasUnsupportedContent = xmlDoc => Array.from(xmlDoc.getElementsByTagName("*")).some(element => (
    element.getAttribute("xml:space") === "preserve" ||
    Array.from(element.childNodes).some(node => node.nodeType === CDATA_SECTION_NODE)
  ))

  const beautifyXml = content => {
    if(!content?.trim()) {
      return content
    }

    const xmlDoc = new DOMParser().parseFromString(content, XML_MIME_TYPE)
    if(xmlDoc.getElementsByTagName("parsererror").length || hasMixedContent(xmlDoc) || hasUnsupportedContent(xmlDoc)) {
      return content
    }

    const lines = new XMLSerializer()
      .serializeToString(xmlDoc)
      .replace(/>\s*</g, "><")
      .replace(/></g, ">\n<")
      .split("\n")
    let depth = 0

    return lines.map(line => {
      const trimmedLine = line.trim(),
            isClosingTag = trimmedLine.startsWith("</"),
            isOpeningTag = /^<[^!?/][^>]*>$/.test(trimmedLine) && !trimmedLine.endsWith("/>")

      if(isClosingTag) {
        depth = Math.max(0, depth - 1)
      }

      const formattedLine = `${INDENT.repeat(depth)}${trimmedLine}`
      if(isOpeningTag) {
        depth += 1
      }

      return formattedLine
    }).join("\n")
  }

  const beautify = ({ codeType, content }) => codeType === XML_CODE_TYPE ? beautifyXml(content) : content

  return {
    beautify
  }
})()
